import { CustomSelectOption, Select as VkuiSelect } from '@vkontakte/vkui';
import type { ChangeEvent } from 'react';
import { ChevronDownIcon } from '../icons';
import styles from './ui.module.css';

/**
 * Выбор из списка — обёртка над вкуишным `Select`.
 *
 * Берём именно его, а не `CustomSelect`: он сам решает по устройству —
 * на десктопе рисует список (`CustomSelect`), на телефоне отдаёт родной
 * `<select>` с барабаном системы. Клавиатура, фокус, ARIA и переворот списка
 * у нижнего края тоже его.
 *
 * Наш только вид, и он весь на токенах: поверхность списка красит
 * `--vkui--color_background_contrast_themed` (задан в `theme/tokens.css` —
 * «contrast» у VKUI в тёмной теме БЕЛЫЙ, он для тултипов), рамку —
 * `--vkui--color_field_border_alpha`, строку — свой класс через `renderOption`.
 * В имена его классов не целимся.
 */
export interface SelectOption {
  value: string;
  label: string;
}

export function Select({
  value,
  options,
  placeholder,
  disabled = false,
  label,
  onChange,
}: {
  value: string;
  options: readonly SelectOption[];
  placeholder?: string;
  disabled?: boolean;
  label?: string;
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
}) {
  return (
    <VkuiSelect
      className={styles.select}
      value={value}
      options={[...options]}
      placeholder={placeholder}
      disabled={disabled}
      aria-label={label}
      onChange={onChange}
      icon={<ChevronDownIcon />}
      dropdownOffsetDistance={0}
      renderOption={({ option, ...rest }) => (
        <CustomSelectOption {...rest} key={option.value} className={styles.selectOption} />
      )}
    />
  );
}
